import { Component, ComponentFactoryResolver } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { initAspMngr, AspMngr } from '@core_n/asp/AspMngr';
import { SensorBiasMngr } from './sensor-bias/sensor-bias';
import { DisplayFilterComponent } from '@core_n/display-filter/display-filter.component';
import { CoreAppComponent } from '@core_n/core-app.component';
import { SensorsPool } from './asp/SensorsPool';
import { PlotsPool } from './asp/PlotsPool';
import { IMapMngr, IObjectsPool } from '@core_n/asp/interfaces';
import { SensorsDrawer } from './asp/SensorsDrawer';
import { MapMngr, DrawersFactory } from '@core_n/asp/MapMngr';
import { RulerDisplayObject } from '@core_n/asp/rulers';
import { AcousticVectorDisplayObject } from '@core_n/asp/acousticVectorDisplayObject';
import { TracksDrawer } from './asp/TracksDrawer';
import { TracksPool } from './asp/TracksPool';
import { AcousticVectorPool } from '../core/app/asp/acousticVectorPool';
import { initConstants } from '@core_n/common/consts';
import { ProjConstants } from './common/projConsts';
import { initUserSettings } from '@core_n/common/settings';
import { setAroTrackComponentFactory } from '@core_n/aro/aro-track-core.component';
import { AroTrackComponent } from './aro/aro-track.component';
import { setAroPlotComponentFactory } from '@core_n/aro/aro-plot-core.component';
import { AroPlotComponent } from './aro/aro-plot.component';
import { StatusBarService } from '@core_n/status-bar/status-bar.service';
import { TranslateService } from '@ngx-translate/core';
import * as consts from '../core/app/common/consts';
import { ImpactPointHandler } from './asp/ImpactPoint';
import { ThreatPolygonHandler } from './asp/ThreatPolygon';
import { ClsArmHandler } from './asp/ClsArm';
import { ErrNotificationsHandler } from './asp/ErrNotifications';
import { DTM } from './asp/DTM';
import { NaiNatHandler } from './asp/NaiNatHandler';
import { ParamsHandler } from './asp/ParamHandler';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { PlaybackHandler } from './asp/PlaybackHandler';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { AlertMsgMngrService } from '@core_n/msg/alert-msg-mngr.service';

export class MyDrawersFactory extends DrawersFactory {

  createSensorsDrawer(mapMngr: IMapMngr, objectsPool: IObjectsPool, parentLayer) {
    return new SensorsDrawer(mapMngr, objectsPool, parentLayer);
  }

  createTracksDrawer(mapMngr: IMapMngr, objectsPool: IObjectsPool, parentLayer) {
    return new TracksDrawer(mapMngr, objectsPool, parentLayer);
  }

}

@Component({
  selector: 'app-root',
  templateUrl: '../core/app/core-app.component.html'
})
export class AppComponent extends CoreAppComponent {

  constructor(matIconRegistry: MatIconRegistry,
    msgBoxService: MsgBoxService,
    domSanitizer: DomSanitizer,
    componentFactoryResolver: ComponentFactoryResolver,
    statusBarService: StatusBarService,
    _translateService: TranslateService,
    private videoMngrSrvc: VideoMsgMngrService,
    private alertMngr: AlertMsgMngrService) {
    super(matIconRegistry, domSanitizer, componentFactoryResolver, _translateService);

    initConstants(new ProjConstants(), _translateService);
    initUserSettings(this.videoMngrSrvc, this.alertMngr);

    setAroTrackComponentFactory(componentFactoryResolver.resolveComponentFactory(AroTrackComponent));
    setAroPlotComponentFactory(componentFactoryResolver.resolveComponentFactory(AroPlotComponent));

    DisplayFilterComponent.setFilterTrackIdent(false);

    RulerDisplayObject.setShowElevation(true);
    // AcousticVectorDisplayObject.setShowElevation(true);

    MapMngr.setDrawersFactory(new MyDrawersFactory());

    // INIT HANDLERS
    SensorBiasMngr.getSelf();
    ImpactPointHandler.getSelf();
    ThreatPolygonHandler.getSelf();
    ClsArmHandler.getSelf();
    ErrNotificationsHandler.getSelf(msgBoxService);
    DTM.getSelf();
    NaiNatHandler.getSelf();
    ParamsHandler.getSelf();
    PlaybackHandler.getSelf();

    let aspMngr = new AspMngr();
    aspMngr.setSensorsPool(new SensorsPool());
    aspMngr.setPlotsPool(new PlotsPool());
    aspMngr.setTracksPool(new TracksPool());
    aspMngr.setAcousticVector(AcousticVectorPool.getSelf());
    initAspMngr(aspMngr);
    localStorage.setItem(consts.LOCAL_STORAGE_SHOW_DTM_KEY, JSON.stringify(false));
    statusBarService.statusBarVisible = true;
  }

}
